import {Layout} from "@components";
import React from "react";
import styles from "./style.module.scss";
import {useRecoilValue} from "recoil";
import {states} from "@recoils";
import {Images} from "@assets";

export default function HomePage() {
  const infoData = useRecoilValue(states.infoDataState);
  const data = infoData.find(item => item.type === "organization");
  const imgUrl = data?.files?.[0]?.url;

  return (
    <Layout>
      <div className={styles.container}>
        <img src={imgUrl ?? Images.noImage} alt="조직도" />
      </div>
    </Layout>
  );
}
